import { apiFetch } from "@/client/lib/api";
import type { DocSlot } from "@/shared/doc-slots";

/** Staff-only client for managing contextual doc placements (global config). */

export interface PlacementAdminView {
  id: string;
  slot: string;
  outlineDocumentId: string;
  docTitle: string | null;
  label: string | null;
  description: string | null;
  position: number;
  enabled: boolean;
}

export interface AvailableDoc {
  outlineDocumentId: string;
  title: string;
}

export interface CreatePlacementInput {
  slot: string;
  outlineDocumentId: string;
  label?: string;
  description?: string;
  position?: number;
}

export interface UpdatePlacementInput {
  label?: string | null;
  description?: string | null;
  position?: number;
  enabled?: boolean;
}

export const placementsAdminApi = {
  listSlots: () => apiFetch<{ slots: DocSlot[] }>("/staff/docs/slots"),
  listAvailable: () => apiFetch<{ docs: AvailableDoc[] }>("/staff/docs/available"),
  list: () => apiFetch<{ placements: PlacementAdminView[] }>("/staff/docs/placements"),
  create: (input: CreatePlacementInput) =>
    apiFetch<PlacementAdminView>("/staff/docs/placements", { method: "POST", json: input }),
  update: (id: string, input: UpdatePlacementInput) =>
    apiFetch<PlacementAdminView>(`/staff/docs/placements/${encodeURIComponent(id)}`, {
      method: "PATCH",
      json: input,
    }),
  remove: (id: string) =>
    apiFetch<void>(`/staff/docs/placements/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
